export default class User {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  email: string | null;
  avatar: string | null;
  id: string;
  identityId: string;
  plan: string;
  seats: number;
  spaceId: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
